import { useRef, useEffect } from 'react';

var useTruncateText = truncateText => {
  var contentText = useRef(null);
  useEffect(() => {
    if (truncateText) {
      var contentElement = contentText.current;

      if (contentElement) {
        var initialWords = contentElement.innerHTML;
        var wordsArray = initialWords.split(' ');
        /**
         * TODO: Find better contentValues values for the logic.
         * Secondary Theme truncated content gets stuck in the while loop because
         * there are different dimensions at play.
         */

        var ARBITRARY_SECONDARY_OFFSET = 5;

        while (contentElement.scrollHeight > contentElement.offsetHeight + ARBITRARY_SECONDARY_OFFSET && wordsArray.length !== 0) {
          wordsArray.pop();
          contentElement.innerHTML = "".concat(wordsArray.join(' '), "...");
        }
        /**
         * If while loop pops all words due to element dimensions,
         * prefer resetting without truncating to potentially
         * broken functionality
         */


        if (wordsArray.length === 0) {
          contentElement.innerHTML = initialWords;
        }
      }
    }
  });
  return {
    contentText
  };
};

export { useTruncateText };
